import { FunctionBrick, registerBrick, GlobalProperties, BrickContext, ErrorFlow } from 'olympe';
import ReactDOM from 'react-dom';
import React from 'react';
import { BackendErrorAlert } from '../components/shared/BackendErrorAlert.jsx';

/**
 * Shows an alert when an error happens in the backend while fetching (GET) data
 */
export default class ShowFetchBackendAlert extends FunctionBrick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {ErrorFlow} error
     * @param {function(): void} forwardEvent
     */
    update($, [error, mainLine], [forwardEvent]) {
        // show only one alert at a time
        const isPopupPresented = document.getElementById('error-alert') !== null;
        if (isPopupPresented) {
            return;
        }
        if (!$.get(GlobalProperties.EDITION, true)) {
            const head = document.body;
            const errorAlert = document.createElement('error-alert');
            errorAlert.id = 'error-alert';
            head.appendChild(errorAlert);

            const errorCode = error.getCode();
            let title = 'Backend Error';
            if (errorCode >= 400 && errorCode < 600) {
                title = 'SAP Backend Error';
            }

            ReactDOM.render(
                <BackendErrorAlert
                    title={title}
                    mainLine={mainLine || BackendErrorAlert.FETCH_EXPLANATION}
                    smallLine1={error.getMessage()}
                    smallLine2={errorCode === 401 ? BackendErrorAlert.PERMISSION_REASON : ''}
                    onClose={() => {
                        errorAlert?.remove();
                    }}
                />,
                errorAlert
            );
        }
        forwardEvent();
    }
}

registerBrick('0182fdf62cea98aeca70', ShowFetchBackendAlert);
